import { Card, Col, Row } from "react-bootstrap";
import { formatoMoneda } from "../../lib/helpers/helpers";
import { key_local_storage_cart, url_images } from '../../lib/backend/data'
import { useSearchParams } from "react-router-dom";
import { capitalizeFirstLetter, toSlug } from "../../lib/helpers/main";
import { FaCirclePlus } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { FaMinus, FaPlus, FaRegTrashAlt } from "react-icons/fa";
import { Chip, Tooltip } from "@mui/material";
import './animation.css';

const BoxListProduct = (props) => {
    const {
        product
    } = props
    const [searchParams, setSearchParams] = useSearchParams();
    const carrito = localStorage.getItem(key_local_storage_cart) ? JSON.parse(localStorage.getItem(key_local_storage_cart) ) : []

    const cantidad = carrito.find((item) => item._id === product._id) ? carrito.find((item) => item._id === product._id).cantidad : 0;

    const seleccionar = () => {
        const params = new URLSearchParams(searchParams);
        params.set("product", product.slug);
        setSearchParams(params)
        if(props.onSelect) props.onSelect(product)
    }

    const onProductRemoved = () => {
      if(props.onProductRemoved) props.onProductRemoved()
    }
    const onAdd = () => {
      if(props.onAdd) props.onAdd()
    }

    const onMinus = () => {
      if(props.onMinus) props.onMinus()
    }

    const addToCart = () => {
      if(props.addToCart) props.addToCart()
    }

    const mostrarBoton = () => {
      const sizeIcon = 10
      const reachedMax = typeof product.totalStock === "number" && product.totalStock >= 0 && cantidad >= product.totalStock
      const plusStyle = { display: "inline-block", width: "20%", opacity: reachedMax ? 0.5 : 1 }
      if(!cantidad) {
        const content = <div style={{ position: "absolute", bottom: 0, right: 15, opacity: reachedMax ? 0.5 : 1 }}><FaCirclePlus onClick={() => addToCart()} size={25} /></div>
        return reachedMax ? <Tooltip title="Sin stock">{content}</Tooltip> : content
      }
      return <div className="text-white pl-2 pr-2" style={{ width: 70, borderRadius: 10, position: "absolute", bottom: 0, right: 15, backgroundColor: "black" }}>
        <div className="align-items-center text-center">
          <div className="" style={{ display: "inline-block", width: "20%" }}>
            { cantidad === 1 ? <FaRegTrashAlt size={sizeIcon} onClick={() => onProductRemoved()}/> : <FaMinus onClick={() => onMinus()} size={sizeIcon} /> }
          </div>
          <div className="p-1 " style={{ display: "inline-block", width: "60%" }}><p className="mb-0" style={{ fontSize: 14 }}><b>{cantidad}</b></p></div>
          <div  style={plusStyle}>{ reachedMax ? <Tooltip title="Sin stock"><FaPlus onClick={() => onAdd()} size={sizeIcon} /></Tooltip> : <FaPlus onClick={() => onAdd()} size={sizeIcon} /> }</div>
        </div>
      </div>
    }
    return <Card className='p-3 mb-4' >
    <Row>
      <Col xs={8} onClick={() => seleccionar()}>
          <h6 className='mb-0' style={{ fontSize: 13 }}>{capitalizeFirstLetter(product.titulo)}</h6>
          {product.descripcion ? <p className='mb-0' style={{ fontSize: 13, color: "gray", textTransform: "lowercase" }}>{product.descripcion}</p> : false }
        <h6 className="mb-0" style={{ fontWeight: 600, color: "black" }}>${formatoMoneda(product.precio)} {product.original_price ? <b style={{ textDecoration: "line-through", fontWeight: "lighter", color: "gray", fontSize: 12,  }}>{formatoMoneda(product.original_price)}</b> : false }</h6>
        {product.original_price ? <Chip sx={{ fontSize: 11 }} size="small" label="Oferta" className="gradient-animated" /> : false }
      </Col>
      <Col xs={4} >
      {mostrarBoton()}
      <div className="hover" onClick={() => seleccionar()} style={{ margin: "0 auto", width: "100%", aspectRatio: "1 / 1", backgroundSize: "cover", backgroundPosition: "center center", width: "100%", backgroundImage: `url('${product.img ? product.img : `${url_images}/product.png`}' )` }} />
      </Col>
    </Row>
    </Card>
}

export default BoxListProduct;
